import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Clearfix } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import IntlDateTime from 'components/layout/IntlDateTime';
import FabActions from 'components/layout/FabActions';
import FabActionElement from 'components/layout/FabActionElement';

import LeadActions from 'components/layout/lead/LeadActions';

class LeadInfos extends React.Component {
  getProgress = () => {
    const { appIntl, lead } = this.props;

    let currentProgress = 0;
    if (lead.current_stage) {
      currentProgress = _findIndex(lead.pipeline.stages, ['id', lead.current_stage]);
    }
    const countStages = lead.pipeline.stages.length;

    const progressElements = [];
    for (let j = 0; j < countStages; j++) {
      progressElements.push(
        <div class="pull-left" style={{ width: (1 / countStages) * 100 + '%' }} key={j}>
          <div class={'m-r-5 bg-' + (j <= currentProgress ? 'primary-light' : 'white')} style={{ height: '3px' }} />
        </div>
      );
    }

    return (
      <dd class="m-t-5 sm-m-t-0 p-t-10 p-b-5">
        <div class="clearfix m-b-10">{progressElements}</div>

        {getNameInCurrentLanguage(lead.pipeline.stages[currentProgress].name, appIntl)}
      </dd>
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      showActions,
      addEditAction,
      lead,
      history,
    } = this.props;

    const addActions = [];
    if (addEditAction) {
      addActions.push(
        <FabActionElement
          size="60"
          icon="fas fa-pencil-alt"
          caption={messages.edit}
          action={() => history.push(appIntl.urlPrefix + 'account/leads/' + (lead.id || lead.getId()))}
        />
      );
    }

    return (
      <Clearfix>
        <dl class="no-margin full-width">
          <dt>{messages.pipeline}</dt>
          <dd>
            <IntlFormInlineSelector />
            {getNameInCurrentLanguage(lead.pipeline.name, appIntl)}
          </dd>

          <dt />
          {this.getProgress()}

          <dt class="m-t-5">{messages.title}</dt>
          <dd>{lead.title}</dd>

          <dt class="m-t-5">{messages.date_created}</dt>
          <dd>
            <IntlDateTime date={lead.cdate} />
          </dd>
        </dl>

        {showActions && (
          <div class="top-right m-t-20" style={{ marginLeft: '-70px' }}>
            <FabActions>
              <LeadActions
                lead={lead.processedData ? lead.processedData : lead}
                wrapperComponent={null}
                listItemComponent={<FabActionElement size="60" />}
                addActions={addActions}
              />
            </FabActions>
          </div>
        )}
      </Clearfix>
    );
  }
}
LeadInfos.defaultProps = {
  showActions: true,
  addEditAction: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(LeadInfos)));
